import type { ISODateTimeString } from '../BrandedTypes'

export const Stakeholder = {
  V1: {
    Added: 'Stakeholders.V1.StakeholderAdded',
    GeneralInfoChanged: 'Stakeholders.V1.StakeholderGeneralInfoChanged',
    InternalIdentificationNumbersChanged:
      'Stakeholders.V1.StakeholderSystemReferenceNumbersChanged',
    OfficialBusinessNumbersChanged:
      'Stakeholders.V1.StakeholderOfficialBusinessNumbersChanged',
    PostalAddressChanged: 'Stakeholders.V1.StakeholderPostalAddressChanged',
    VisitAddressChanged: 'Stakeholders.V1.StakeholderVisitAddressChanged',
    BillingDetailsChanged: 'Stakeholders.V1.StakeholderBillingDetailsChanged',
    Removed: 'Stakeholders.V1.StakeholderRemoved',
    Restored: 'Stakeholders.V1.StakeholderRestored',
    StakeholderContactAdded: 'Stakeholders.V1.StakeholderContactAdded',
    StakeholderContactUpdated:
      'Stakeholders.V1.StakeholderContactDetailsUpdated',
    StakeholderContactRemoved: 'Stakeholders.V1.StakeholderContactRemoved'
  }
} as const

export type StakeholderContactAddedSignalRPayload = {
  contactId: string
  contactType: string
  department: string | null
  directLine: string | null
  email: string | null
  firstName: string | null
  jobTitle: string | null
  lastName: string | null
  mobilePhone: string | null
  occuredAt: ISODateTimeString
  otherName: string | null
  stakeholderId: string
  stakeholderName: string
}

export type StakeholderContactUpdatedSignalRPayload = {
  contactId: string
  contactType: string
  department: string | null
  directLine: string | null
  email: string | null
  firstName: string | null
  jobTitle: string | null
  lastName: string | null
  mobilePhone: string | null
  occuredAt: ISODateTimeString
  otherName: string | null
  stakeholderId: string
  stakeholderName: string
}

export type StakeholderContactDeletedSignalRPayload = {
  contactId: string
  contactType: string
  firstName: string | null
  lastName: string | null
  occuredAt: ISODateTimeString
  otherName: string | null
  stakeholderId: string
  stakeholderName: string
}

// Stakeholder-level events: the backend sends a thin envelope with just the
// identifier and timestamp — consumers are expected to re-fetch via the API
// to get the latest state. Previously these types declared richer fields
// (name, postalAddress, stakeholderType, etc.) that the backend does not
// actually include, which silently broke handlers that filtered on those
// fields. Kept as distinct named types so per-event fields can be added
// back if the backend ever enriches a specific event.
export type StakeholderAddedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderVisitAddressChangedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderPostalAddressChangedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderGeneralInfoChangedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderInternalIdentificationNumbersChangedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderOfficialBusinessNumbersChangedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderBillingDetailsChangedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderRemovedSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}

export type StakeholderRestoredSignalRPayload = {
  occuredAt: ISODateTimeString
  stakeholderId: string
}
